import { ROLES } from "src/app/constants/roles";

const INTERNAL_EMAIL_DOMAINS = ["@convercus.com", "@coara.co"];

export function isInternalUser(authorities: readonly string[] | null | undefined, email: string | null | undefined): boolean {
  if (authorities?.includes(ROLES.SUPER_ADMIN)) return true;
  const normalizedEmail = email?.trim().toLowerCase();
  return !!normalizedEmail && INTERNAL_EMAIL_DOMAINS.some(domain => normalizedEmail.endsWith(domain));
}
